// Changes made here should also be made to Ewn.Validation.Security.PasswordResetValidator.MeetComplexityRequirements.
export function validatePassword (value) {
  const r = {};
  if (!value) return { valid: false, hasLength: false };
  r.hasLength = value.length >= 8;
  const freqs = {};
  // eslint-disable-next-line no-cond-assign
  for (let i = 0, lastChar, c; c = value.charAt(i); i++, lastChar = c) {
    // Must not repeat the same character more than 3 times
    const count = freqs[c] = (lastChar === c ? (freqs[c] || 0) : 0) + 1;
    if (count >= 3) {
      r.hasRepeats = true;
    }

    if (c.toUpperCase() === c && c.toLowerCase() !== c) {
      r.hasUpper = true; // Must contain an uppercase letter
    } else if (c.toLowerCase() === c && c.toUpperCase() !== c) {
      r.hasLower = true; // Must contain a lowercase letter
    } else if (!isNaN(parseInt(c, 10))) {
      r.hasNumber = true; // Must contain a number
    } else if (c === ' ' || !/\s/.test(c)) {
      r.hasSpecial = true; // Must contain a special character
    } else {
      r.hasInvalid = true; // No other types of whitespace allowed (tabs, newlines, etc.)
    }
  }
  r.hasEnough = (!!r.hasUpper + !!r.hasLower + !!r.hasNumber + !!r.hasSpecial) >= 3;
  r.isValid = r.hasLength && r.hasEnough && !r.hasRepeats && !r.hasInvalid;
  return r;
}
